<template>
  <el-dialog
    id="SampleMix"
    :title="num === 1 ? '单采' : num + '人混采'"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div v-loading="dialogLoading">
      <el-row>
        <el-col :span="24">
          <span style="color: red">*</span>样本管码
        </el-col>
        <el-col :span="24">
          <el-input style="width: 100%;margin-top: 15px;" ref="sampleSn" v-model="sampleSn" placeholder="请扫描样本管码" @keyup.enter.native="handleSampleSn" clearable></el-input>
        </el-col>
      </el-row>
      <!--<el-row style="flex-flow: row;">-->
        <!--<el-col :span="6">-->
          <!--<span style="color: red">*</span>检验项目-->
        <!--</el-col>-->
        <!--<el-col :span="18">-->
          <!--<el-select-->
            <!--style="width: 100%"-->
            <!--v-model="dataForm.itemInfo"-->
            <!--filterable-->
            <!--remote-->
            <!--reserve-keyword-->
            <!--placeholder="请输入服务项目名称"-->
            <!--:remote-method="remoteMethod"-->
            <!--:loading="loading"-->
            <!--value-key="id"-->
            <!--clearable>-->
            <!--<el-option-->
              <!--v-for="item in options"-->
              <!--:key="item.id"-->
              <!--:label="item.label"-->
              <!--:value="item.obj">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</el-col>-->
      <!--</el-row>-->
      <el-row>
        <el-col :span="24">
          健康云登记码
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%"
            @cell-click="cellClick">
            <el-table-column
              width="30"
              type="expand">
              <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand" style="background-color: #F0F4EA;color: #666666;padding: 10px 0 10px 30px;" v-if="props.row.mobile">
                  <!--<el-form-item label="证件类型">-->
                    <!--<span v-if="props.row.cardType === '1'">身份证</span>-->
                    <!--<span v-else-if="props.row.cardType === '5'">港澳居民往来大陆通行证</span>-->
                    <!--<span v-else-if="props.row.cardType === '71'">台湾居民来往大陆通行证（五年有效）</span>-->
                    <!--<span v-else-if="props.row.cardType === '72'">台湾居民来往大陆通行证（一次有效）</span>-->
                    <!--<span v-else-if="props.row.cardType === '31'">华侨护照</span>-->
                    <!--<span v-else-if="props.row.cardType === '3'">外籍护照</span>-->
                    <!--<span v-else-if="props.row.cardType === '9'">其他</span>-->
                  <!--</el-form-item>-->
                  <el-form-item label="证件号">
                    <span>{{ props.row.cardNo }}</span>
                  </el-form-item>
                  <el-form-item label="手机号">
                    <span>{{ props.row.mobile }}</span>
                  </el-form-item>
                  <el-form-item label="性别">
                    <span v-if="props.row.gender === '2'">女</span>
                    <span v-else-if="props.row.gender === '1'">男</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column
              type="index"
              align="center"
              width="55"
              label="序号">
            </el-table-column>
            <el-table-column
              prop="registerId"
              header-align="center"
              align="center"
              show-overflow-tooltip
              label="登记码">
              <template slot-scope="scope">
                <el-input :ref="'register' + scope.$index" v-model="scope.row.registerId" @keyup.enter.native="getInfo(scope.row, scope.$index)" :placeholder="!!scope.row.snCode? '' : '请扫描'" :disabled="!!scope.row.snCode" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="realName"
              header-align="center"
              align="center"
              show-overflow-tooltip
              label="登记信息"
              width="160">
              <template slot-scope="scope">
                <div style="color: #00C5B0;display: flex;justify-content: space-between;align-items: center;padding-right: 15px;">
                  <div>
                    <p style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{scope.row.realName}}</p>
                    <p style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{scope.row.mobile}}</p>
                  </div>
                  <i class="el-icon-delete" v-if="scope.row.realName" @click.stop="handleDelete(scope.$index)"></i>
                </div>
              </template>
            </el-table-column>
            <!--<el-table-column-->
              <!--prop="cardType"-->
              <!--header-align="center"-->
              <!--align="center"-->
              <!--show-overflow-tooltip-->
              <!--label="证件类型">-->
              <!--<template slot-scope="scope">-->
                <!--<span v-if="scope.row.cardType === '1'">身份证</span>-->
                <!--<span v-else-if="scope.row.cardType === '5'">港澳居民往来大陆通行证</span>-->
                <!--<span v-else-if="scope.row.cardType === '71'">台湾居民来往大陆通行证（五年有效）</span>-->
                <!--<span v-else-if="scope.row.cardType === '72'">台湾居民来往大陆通行证（一次有效）</span>-->
                <!--<span v-else-if="scope.row.cardType === '31'">华侨护照</span>-->
                <!--<span v-else-if="scope.row.cardType === '3'">外籍护照</span>-->
                <!--<span v-else-if="scope.row.cardType === '9'">其他</span>-->
              <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
              <!--prop="cardNo"-->
              <!--header-align="center"-->
              <!--align="center"-->
              <!--show-overflow-tooltip-->
              <!--label="证件号">-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
              <!--prop="mobile"-->
              <!--header-align="center"-->
              <!--align="center"-->
              <!--show-overflow-tooltip-->
              <!--label="手机号">-->
            <!--</el-table-column>-->
            <!--<el-table-column-->
              <!--prop="gender"-->
              <!--header-align="center"-->
              <!--align="center"-->
              <!--show-overflow-tooltip-->
              <!--label="性别">-->
              <!--<template slot-scope="scope">-->
                <!--<span v-if="scope.row.gender === 2">女</span>-->
                <!--<span v-else-if="scope.row.gender === 1">男</span>-->
              <!--</template>-->
            <!--</el-table-column>-->
          </el-table>
        </el-col>
      </el-row>
      <el-row style="text-align: center;">
        <el-col :span="24">
          <el-button style="width: 200px;height: 45px;" type="primary" @click="handleConfirm">完成录入</el-button>
        </el-col>
        <el-col :span="24" style="margin-top: 5px;">
          <el-checkbox v-model="checked">继续录入下一个</el-checkbox>
        </el-col>
      </el-row>
      <!--请扫描样本管码-->
      <audio id="audio1" src="https://v.jianyanwang.com/1.mp3" style="display: none"></audio>
      <!--样本管扫描成功，请扫描健康云登记码-->
      <audio id="audio2" src="https://v.jianyanwang.com/2.mp3" style="display: none"></audio>
      <!--登记成功-->
      <audio id="audio3" src="https://v.jianyanwang.com/3.mp3" style="display: none"></audio>
      <!--当前采样管已满,提交成功-->
      <audio id="audio4" src="https://v.jianyanwang.com/4.mp3" style="display: none"></audio>
      <!--登记失败,请检查-->
      <audio id="audio5" src="https://v.jianyanwang.com/5.mp3" style="display: none"></audio>
      <!--登记重复,请重新扫描-->
      <audio id="audio6" src="https://v.jianyanwang.com/6.mp3" style="display: none"></audio>
      <!--样本管码无效,请重新扫描-->
      <audio id="audio7" src="https://v.jianyanwang.com/7.mp3" style="display: none"></audio>
      <!--当前样本管已有采样信息,请检查-->
      <audio id="audio8" src="https://v.jianyanwang.com/8.mp3" style="display: none"></audio>
      <!--删除成功-->
      <audio id="audio9" src="https://v.jianyanwang.com/9.mp3" style="display: none"></audio>
      <!--无可删除信息-->
      <audio id="audio10" src="https://v.jianyanwang.com/10.mp3" style="display: none"></audio>
      <!--删除失败-->
      <audio id="audio11" src="https://v.jianyanwang.com/11.mp3" style="display: none"></audio>
      <!--当前采样管保存成功-->
      <audio id="audio12" src="https://v.jianyanwang.com/12.mp3" style="display: none"></audio>
    </div>
  </el-dialog>
</template>

<script>
  import axios from 'axios'
  import {deepClone} from "../util/util"

  export default {
    name: 'sample-mix',
    data() {
      return {
        visible: false,
        dataForm: {
          itemInfo: ''
        },
        itemId: '',
        sampleSn: '',
        tableData: [],
        options: [],
        loading: false,
        num: 0,
        checked: true,
        dialogLoading: false
      }
    },
    methods: {
      init (num, id) {
        let _this = this
        this.num = num
        this.itemId = id
        this.visible = true
        this.sampleSn = ''
        this.tableData = []
        for (let i = 0 ; i < num ; i++) {
          this.tableData.push({
            registerId: '',
            realName: '',
            cardType: '',
            cardNo: '',
            mobile: '',
            gender: ''
          })
        }
        this.remoteMethod('')
        this.$nextTick(() => {
          this.$refs['sampleSn'].focus()
          setTimeout(function () {
            _this.handleAudio('audio1')
          }, 200)
        })
      },

      cellClick(row, column, event) {
        if(event.cellIndex !== 0){
          this.$refs.multipleTable.toggleRowExpansion(row)
        }
      },

      async getInfo (row, index) {
        if (this.sampleSn) {
          if (row.registerId === 'HDKWEGFKEGFKESHFKE') {
            row.registerId = ''
            if (index < 1) {
              this.handleAudio('audio10')
            } else {
              this.handleDelete(index - 1)
            }
          } else if (row.registerId === 'SDHFISUDHFSKDHFKSD') {
            await this.handleAudio('audio12')
            this.handleConfirm()
          } else {
            row.registerId = row.registerId.replace(/[\W]/g,'')
            if (row.registerId) {
              this.dialogLoading = true
              axios.get("/jys/healthCloud/querySampleByRegId?registerId=" + row.registerId
              ).then((res) => {
                if (res.data.code === 0) {
                  if (res.data.sampleInfo.length) {
                    let flag = 0
                    let full = 0
                    for (let i = 0; i < this.tableData.length; i++) {
                      if (this.tableData[i].registerId === row.registerId) {
                        flag++
                      }
                      if (this.tableData[i].registerId !== '') {
                        full++
                      }
                    }

                    if (flag > 1) {
                      this.handleAudio('audio6')
                      this.$toast('请勿重复登记')
                      row.registerId = ''
                    } else {
                      this.$set(this.tableData, index, {registerId: row.registerId, ...res.data.sampleInfo[0]})
                      this.handSubmit(res.data.sampleInfo[0], full === this.num, index)
                    }

                    // if (full === this.num) {
                    // this.$confirm('当前' + this.num + '人混采采样管已满，是否提交?', '提示', {
                    //   confirmButtonText: '确定',
                    //   cancelButtonText: '取消',
                    //   type: 'warning'
                    // }).then(() => {
                    //   this.handSubmit()
                    // }).catch(() => {})
                    //   this.handleAudio('audio4')
                    //   this.handleConfirm()
                    // }
                  } else {
                    this.handleAudio('audio5')
                    this.$toast('没有识别到用户信息')
                  }
                }
              }).finally(() => this.dialogLoading = false)
            } else {
              this.$toast('请扫描正确的登记码')
            }
          }
        } else {
          this.$toast('样本管码不能为空')
        }
      },

      handleSampleSn () {
        this.sampleSn = this.sampleSn.replace(/[\W]/g,'')
        if (this.sampleSn) {
          axios.get("/jys/hospSample/getMultiplePatientsBySn?sn=" + this.sampleSn
          ).then((res) => {
            if (res.data.code === 0) {
              if (res.data.patients.length) {
                this.tableData = res.data.patients

                let temp = deepClone(this.num - res.data.patients.length)
                for (let i = 0 ; i < temp ; i++) {
                  this.tableData.push({
                    registerId: '',
                    realName: '',
                    cardType: '',
                    cardNo: '',
                    mobile: '',
                    gender: ''
                  })
                }

                this.handleAudio('audio8')
              } else {
                this.tableData = []
                for (let i = 0 ; i < this.num ; i++) {
                  this.tableData.push({
                    registerId: '',
                    realName: '',
                    cardType: '',
                    cardNo: '',
                    mobile: '',
                    gender: ''
                  })
                }

                this.$refs['register0'].focus()
                this.handleAudio('audio2')
              }
            } else {
              if (res.data.msg === '样本已完成登记' || res.data.msg === '样本已登记，当前账号无权限查看') {
                this.handleAudio('audio8')
              }
            }
          })
        } else {
          this.handleAudio('audio7')
        }
      },

      remoteMethod (query) {
        this.loading = true
        axios.get("/jys/hospSample/services", {
          params: {
            name: query
          }
        }).then((res) => {
          this.loading = false
          if (res.data.code === 0) {
            this.options = res.data.list.map(item => {
              return { id: `${item.id}`, label: `${item.itemName}`, obj: {id: item.id, itemName: item.itemName} }
            })
          }
        })
      },

      async handSubmit (sampleInfo, flag, index) {
        if (this.sampleSn) {
          await this.handleSave(sampleInfo, index)
          if (flag) {
            await this.handleAudio('audio3')
            await this.handleAudio('audio4')
            this.handleConfirm()
          } else {
            this.handleAudio('audio3')
          }
        } else {
          this.$toast('样本管码不能为空')
        }
      },

      handleSave (sampleInfo, index) {
        return new Promise((resolve, reject) => {
          axios.post("/jys/hospSample/submitXinguanMultiple", {
            sampleSn: this.sampleSn,
            sampleList: [sampleInfo],
            itemId: this.itemId,
            max: this.num
          }).then((res) => {
            if (res.data.code === 0) {
              this.$toast('操作成功')
              this.$emit('refreshDataList')
              this.$refs['register' + (index + 1)] && this.$refs['register' + (index + 1)].focus()
              resolve()
            } else {
              this.$toast(res.data.msg)
              this.$set(this.tableData, index, {
                registerId: '',
                realName: '',
                cardType: '',
                cardNo: '',
                mobile: '',
                gender: ''
              })
              reject()
            }
          })
        })
      },

      handleConfirm () {
        if (this.checked) {
          this.init(this.num, this.itemId)
        } else {
          this.visible = false
          this.$emit('closeItem')
          this.$router.replace("/mine/sampleManage")
        }
      },

      handleAudio (id) {
        return new Promise((resolve, reject) => {
          let audioList = document.getElementsByTagName('audio')
          for (let i = 0 ; i < audioList.length ; i++) {
            audioList[i] && audioList[i].pause()
          }
          document.getElementById(id).play()
          document.getElementById(id).loop = false
          document.getElementById(id).addEventListener('ended', function () {
            resolve()
          }, false)
        })
      },

      handleDelete (index) {
        let _this = this
        axios.post("/jys/hospSample/removeMultiplePatient", {
          sampleSn: this.sampleSn,
          sampleList: [this.tableData[index]],
        }).then((res) => {
          if (res.data.code === 0) {
            this.tableData.splice(index, 1)
            this.tableData.push({
              registerId: '',
              realName: '',
              cardType: '',
              cardNo: '',
              mobile: '',
              gender: ''
            })
            this.handleAudio('audio9')

            this.$nextTick(() => {
              setTimeout(function () {
                _this.$refs['register' + index] && _this.$refs['register' + index].focus()
              }, 200)
            })
          } else {
            this.handleAudio('audio11')
          }
        })
      }
    }
  }
</script>

<style scoped>
  * {
    font-size: 15px;
  }
  #SampleMix >>> .el-dialog__header{
    text-align: center;
  }
  #SampleMix >>> .el-dialog__title{
    color: #000000;
    font-size: 17px;
    font-weight: bold;
  }
  #SampleMix >>> .el-dialog__body{
    padding: 20px 5%;
    color: #000000;
  }
  #SampleMix >>> .el-table__expanded-cell {
    padding: 0;
  }
  #SampleMix >>> .el-table__expanded-cell .el-form-item--small.el-form-item {
    margin-bottom: 0;
    display: block;
  }
  #SampleMix >>> .el-input--small .el-input__inner {
    height: 45px;
    line-height: 45px;
  }
  #SampleMix >>> .el-table th {
    background-color: #00C5B0;
    color: #ffffff;
    border-color: #ffffff;
  }
  #SampleMix >>> .el-table__body-wrapper {
    height: 310px;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/sample-mix.vue